"use strict";

var Backbone            = require("backbone");

/**
 * AnnotationModel : annotation sur une page de document
 */
module.exports = Backbone.Model.extend({
  
    defaults: {
        publicationId:0,
        documentId:0,
        page:0,
        text:null,
        top:0,
        left:0,
        timestamp:0
    }

});